export const environment = {
  name: '開発環境',
  production: false
};

export const API_URL = 'http://reserve.joyfit.townsystem.co.jp/ems_api';

export const AWS = {
  displayMode: 'ログイン  (Development Mode)',
  // REQUIRED - Amazon Cognito Identity Pool ID
  identityPoolId: 'ap-southeast-2:65a3ead4-c573-4cd0-9db4-622f208cd827', 
  // REQUIRED - Amazon Cognito Region
  region: 'ap-southeast-2', 
  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: 'ap-southeast-2_xaDGbfmLG',
  // OPTIONAL - Amazon Cognito Web Client ID
  userPoolWebClientId: '5piej7tg3ik3i52kstuccrfqu8', 
  // AWS endpoint name
  endPointName: 'AmplifyTest',
  // AWS endpoint
  endPoint: 'https://dh83oi26f4.execute-api.ap-southeast-2.amazonaws.com/Prod',
  /** 強制ログアウトカウントダウンが開始されるまでの無操作時間(秒) */
  timeoutSeconds: 9 * 60 + 30,
  /** 強制ログアウトカウントダウン時間(秒) */
  countdownSeconds: 30,
};

export const IPAD_URL = 'http://192.168.1.143:8080/henpin/api';
export const AWSEC2 = {
  LOGIN_URL : 'http://3.15.141.31/loginDev.php',
  GET_USERS_URL : 'http://3.15.141.31/getusersDev.php',
  UPDATE_USER_URL : 'http://3.15.141.31/updateusersDev.php',
  GET_BUCKETS_URL : 'http://3.15.141.31/getbucketsDev.php',
  UPDATE_BUCKET_URL : 'http://3.15.141.31/updatebucketsDev.php',
  GET_BUCKET_NAME_URL: 'http://3.15.141.31/getbucketnameDev.php',
  UPDATE_USER_TIME_URL: 'http://3.15.141.31/updateusertimeDev.php',
  GET_USER_TIME_URL: 'http://3.15.141.31/getusertimeDev.php'
}
export const FORGECLIENT = {
  CLIENT_ID : 'KsHGfejbWJHkDu5iFj9XM6MF0NLecFmR',
  CLIENT_SECRET : 'GO0GJy01uwp1RxYP'
}
export const MATERIAL_LIST = {
  // "タイル範囲": "283224 255 205 155",
  "タイル既存": "313749 255 205 155",
  "タイル浮き(張替)": "283225 255 128 0",
  "タイル割れ(張替)": "291015 255 0 0",
  "タイル割れ(注入)": "313666 121 255 255",
  "タイル足場繋ぎ設置(張替)": "313668 255 255 85",
  "タイル改修完了": "313667 255 85 255"
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts